module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-01.0f9928d7.svg";